export default __webpack_public_path__ + "static/media/mamut_s2.dc94f458.png";